import { connect } from 'react-redux';
import { first, size } from 'lodash/fp';
import { createStructuredSelector } from 'reselect';
import { ContentCard } from '@mews-commander/ui';
import { Button } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { openTaskCreationModal } from '../../../tasks/actions/actions';
import { getCheckedReservationIds } from '../../selectors';
import TaskTable from './TaskTable';

const Tasks = ({ createTask, reservationIds, scope }: $TSFixMe) => {
    const handleCreateButtonClick = () => createTask(first(reservationIds));

    return (
        <ContentCard
            title={<LocalizedText textKey={TextKey.TaskPlural} />}
            actions={
                size(reservationIds) === 1 && (
                    <Button onClick={handleCreateButtonClick} type="submit">
                        <LocalizedText textKey={TextKey.CreateTask} />
                    </Button>
                )
            }
        >
            <TaskTable serviceOrderIds={reservationIds} scope={scope} />
        </ContentCard>
    );
};

export default connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        reservationIds: getCheckedReservationIds,
    }),
    (dispatch) => ({
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { resolveRoute }: $TSFixMe) => void' is not assignable to par...
        createTask: (serviceOrderId: $TSFixMe) => dispatch(openTaskCreationModal({ serviceOrderId })),
    })
)(Tasks);
